import { colors, spacing } from "../styles/designTokens";

export function SetupNeededPage({ missing }: { missing: string[] }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: colors.bg,
        display: "grid",
        placeItems: "center",
        padding: spacing.xl,
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: "100%",
          padding: 32,
          borderRadius: 16,
          border: `1px solid ${colors.border}`,
          background: colors.cardBg,
          textAlign: "center",
        }}
      >
        <img
          src="/CostGuard%20Logo%20192x192.png"
          alt=""
          style={{ width: 48, height: 48, marginBottom: 16 }}
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
        <h1 style={{ fontSize: 22, fontWeight: 800, color: colors.text, marginBottom: 8 }}>
          Setup needed
        </h1>
        <p style={{ fontSize: 14, color: colors.textMuted, lineHeight: 1.6, marginBottom: 20 }}>
          CostGuard can&apos;t start because required environment values aren&apos;t set. This is normal on a new system.
        </p>
        <div
          style={{
            textAlign: "left",
            padding: 16,
            borderRadius: 10,
            background: colors.amber6,
            border: `1px solid ${colors.amberBorder}`,
            marginBottom: 16,
          }}
        >
          <div style={{ fontSize: 12, fontWeight: 700, color: colors.amber, marginBottom: 8 }}>
            Missing configuration
          </div>
          {missing.map((key) => (
            <div key={key} style={{ fontSize: 13, color: colors.text, padding: "3px 0", fontFamily: "monospace" }}>
              {key}
            </div>
          ))}
        </div>
        <p style={{ fontSize: 13, color: colors.textMuted, lineHeight: 1.5 }}>
          Firebase keys come from{" "}
          <code style={{ fontSize: 12, padding: "2px 6px", borderRadius: 4, background: colors.white6 }}>
            config/firebase-web-config.staging.json
          </code>{" "}
          (or{" "}
          <code style={{ fontSize: 12, padding: "2px 6px", borderRadius: 4, background: colors.white6 }}>
            .prod.json
          </code>{" "}
          when COSTGUARD_WEB_ENV=prod). Restart the dev server after a config change.
        </p>
      </div>
    </div>
  );
}
